export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7681.9d409805.jpg";